import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage,
// }).plugin

import vuexLocal from './vuex-persist-plugin'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
  plugins: [vuexLocal],
})
